import styled from 'styled-components';
import RightArrowNewIconHome from '../assets/hotels/home/arrow-right-1.svg';

const RightArrowNewIcon = styled(RightArrowNewIconHome as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '2.5rem'};
  fill: ${props => props.fill || props.theme.colors.goBrand.blue};
  margin: ${props => props.margin};
  cursor: ${props => props.disabled ? '' : 'pointer'};
`;

export default RightArrowNewIcon;
